import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/all', label: '动漫大全' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-950/95 backdrop-blur-md shadow-lg shadow-black/20'
          : 'bg-transparent'
      }`}
    >
      <div className="container-custom flex items-center justify-between h-16 md:h-18">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-play-fill text-white text-lg md:text-xl"></i>
          </div>
          <span className="text-xl md:text-2xl font-heading font-bold text-foreground-50 group-hover:text-primary-400 transition-colors">
            6080<span className="text-primary-500">影视</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === link.path
                  ? 'text-primary-400'
                  : 'text-foreground-300 hover:text-foreground-50'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <div className="relative">
            <input
              type="text"
              placeholder="搜索动漫..."
              className="w-48 lg:w-56 h-9 pl-9 pr-3 text-sm bg-background-800/80 border border-background-700 rounded-full text-foreground-200 placeholder-foreground-500 focus:outline-none focus:border-primary-500/50 transition-colors"
            />
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
          </div>
          <Link to="/category/all" className="btn-primary text-sm px-5 py-2 rounded-full">
            开始追番
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-300"
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-950/98 backdrop-blur-md border-t border-background-800">
          <div className="container-custom py-4 flex flex-col gap-3">
            <div className="relative mb-2">
              <input
                type="text"
                placeholder="搜索动漫..."
                className="w-full h-10 pl-9 pr-3 text-sm bg-background-800/80 border border-background-700 rounded-full text-foreground-200 placeholder-foreground-500 focus:outline-none focus:border-primary-500/50"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
            </div>
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'text-foreground-300 hover:bg-background-800 hover:text-foreground-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/category/all" className="btn-primary text-sm px-5 py-2.5 rounded-full text-center mt-1">
              开始追番
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}